import React, { useState, useEffect } from 'react'
import { Row, Col } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CrearUsuario from '../../../components/buttons/crearUsuario';
//Redux
import { connect } from 'react-redux';

// Componets

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const crearUsuario = functionsHttpsCallable('usuarios_crearUsuario');


const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyCreate = (props) => {
    const [email, setEmail] = useState('');
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [pass, setPass] = useState('');
    const [passConf, setPassConf] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    useEffect(() => {
    }, [email]);

    const createUser = async () => {
        props.toggleLoading()
        const body = {
            codigoEmpresa: userData.codigoEmpresa,
            email,
            password: pass,
            username: id,
            firstName: name,
            lastName: lastName,
            token: userData.token
        }
        const createUserReq = await crearUsuario(body);
        if (createUserReq.data.status === 'USUARIO_CREADO') {
            props.toggleLoading()
            props.toastSuccess('Usuario creado con exito!');
            props.toggle()
        }
        else if (createUserReq.data.status === 'USER_ALREADY_EXISTS') {
            props.toggleLoading()
            props.toastError('El usuario ya existe');
        }
        else {
            props.toggleLoading()
            props.toastError('Ocurrió un error');
        }
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            autoComplete='off'
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='correo'
                            margin="normal"
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                    </Col>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            autoComplete='off'
                            key={`key_id`}
                            id={`input_id`}
                            fullWidth
                            label='Cédula'
                            margin="normal"
                            onChange={(e) => { setId(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row className='user-mail-modal'>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            key={`key_pass`}
                            id={`input_pass`}
                            fullWidth
                            type="password"
                            label='Contraseña'
                            margin="normal"
                            onChange={(e) => { setPass(e.target.value) }}
                        />
                    </Col>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            autoComplete='off'
                            key={`key_passConf`}
                            id={`input_passconf`}
                            fullWidth
                            type="password"
                            label='Confirmar Contraseña'
                            margin="normal"
                            onChange={(e) => { setPassConf(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row className='user-mail-modal'>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            autoComplete='off'
                            key={`key_name`}
                            id={`input_name`}
                            fullWidth
                            label='Nombres'
                            margin="normal"
                            onChange={(e) => { setName(e.target.value) }}
                        />
                    </Col>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            autoComplete='off'
                            key={`key_lastname`}
                            id={`input_lastname`}
                            fullWidth
                            label='Apellidos'
                            margin="normal"
                            onChange={(e) => { setLastName(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                        <CrearUsuario
                            onClick={() => createUser()}
                            disabled={!(pass === passConf && name !== undefined && email.includes('@') && id !== undefined && id !== '' > 0 && name !== '' && lastName !== '')} />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyCreate);